import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import TrackVisibility from "react-on-screen";
import videoFireSafety from "../assets/video/Fire Safety.mp4";
import videoBankLoans from "../assets/video/Bank Loans.mp4";
import videoFeedback101 from "../assets/video/Feedback 101_2.mp4";
import videoCustomerCare from "../assets/video/Customer Care.mp4";
import videoPlants from "../assets/video/Plants.mp4";
import videoRecycle from "../assets/video/Recycle.mp4";
import videoElections from "../assets/video/Elections.mp4";
import videoCea from "../assets/video/Cea & Forced Migration.mp4";

import "animate.css";

import level1Img from "../assets/img/lvl1.svg";
import level2Img from "../assets/img/lvl2.svg";
import level3Img from "../assets/img/lvl3.svg";
import level4Img from "../assets/img/lvl4.svg";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import projImg7 from "../assets/img/project-img7.png";
import projImg8 from "../assets/img/project-img8.png";

export const Projects = () => {
  const essential = [
    {
      title: "Elections courses",
      description:
        "A selection of courses developed for various elections committees.",
      videoUrl: videoElections,
      elements:
        "Linear based, Visually appealing, Audio overlay, Interactive, Simulation, Elements movement",
    },
    {
      title: "CEA & Forced Migration",
      description:
        "The course was created for community engagement and accountability in cases with forced migraton. ",
      videoUrl: videoCea,
      elements: "Linear, Interactive, Visually consistent",
    },
  ];
  const defined = [
    {
      title: "Fire Safety",
      description:
        "This course was created with the purpose of showcasing advanced interactive activities for helping and preventing from fire hazards.",
      videoUrl: videoFireSafety,
      elements:
        "Gamified, Interesting interactive elements, Lead character, Practical use",
    },
    {
      title: "Plants - Elementary school",
      description:
        "This course is an introductory course that depicts the basic structure and division of plants, their differences,  care and ways for growing.",
      videoUrl: videoPlants,
      elements: "Visually appealing, Linear, Interactive",
    },
  ];
  const moderate = [
    {
      title: "Feedback 101",
      description:
        "This scenario based course is designed to teach the student on the proper steps on how to deliver a feedback in a corporate setting.",
      videoUrl: videoFeedback101,
      elements: "Scenario based, Interactive, Visually appealing",
    },
    {
      title: "Recycling Course",
      description:
        "Basic principles, process description and practical demonstration for recycling waste and their disposial in a propriate bin for their recycling process.",
      videoUrl: videoRecycle,
      elements:
        "Visually appealing, Gamified elements, Practical knowledge, Animted elements, Audio and video",
    },
  ];
  const immersive = [
    {
      title: "Customer Care",
      description:
        "Interactive guide on handling customer complaints in a travel agency, solving customers complaints and earning points. ",
      videoUrl: videoCustomerCare,
      elements:
        "Interactive, Immersive, Gamified, Scenario based, Custom Visuals, Audio and video",
    },
    {
      title: "Bank Loan",
      description:
        "In this self-paced course, you will go on trip with Sarah and John where you will help them find the best bank loan.",
      videoUrl: videoBankLoans,
      elements:
        "Gamified elements, Scenario based, Custom Visuals, Partial free movement, Real world examples of situations, Immersive",
    },
  ];

  return (
    <section className="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility partialVisibility once>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeInUp" : ""
                  }
                >
                  <h2>SOME OF THE RECENT PROJECTS</h2>
                  <br></br>
                  <Tab.Container defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">
                          <b> ESSENTIAL</b>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">
                          <b> DEFINED</b>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">
                          <b> MODERATE</b>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="forth">
                          <b> IMMERSIVE</b>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="projects"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          <div className="animate__animated animate__zoomIn">
                            <img className="imgLevels" src={level1Img}></img>
                          </div>
                          <p
                            className="animate__animated animate__slideInUp"
                            style={{ color: "white" }}
                          >
                            {" "}
                            All the essential elements delivered in a premium
                            online learning experience
                          </p>
                          {essential.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          <div className="animate__animated animate__zoomIn">
                            <img className="imgLevels" src={level2Img}></img>
                          </div>
                          <p
                            className="animate__animated animate__slideInUp"
                            style={{ color: "white" }}
                          >
                            {" "}
                            A robust and defined e-learning experience that will
                            help your learners tackle learning with ease
                          </p>
                          {defined.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row>
                          <div className="animate__animated animate__zoomIn">
                            <img className="imgLevels" src={level3Img}></img>
                          </div>
                          <p
                            className="animate__animated animate__slideInUp"
                            style={{ color: "white" }}
                          >
                            {" "}
                            Dip your toes in the world of gamified and scenario
                            based e-learning experience
                          </p>
                          {moderate.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="forth">
                        <Row>
                          <div className="animate__animated animate__zoomIn">
                            <img className="imgLevels" src={level4Img}></img>
                          </div>
                          <p
                            className="animate__animated animate__slideInUp"
                            style={{ color: "white" }}
                          >
                            {" "}
                            Immerse in the world of award winning e-learning
                            solution with captivating scenarios, storytelling
                            and more
                          </p>
                          {immersive.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <div className="animate__animated animate__slideInUp">
                        <form
                          method="post"
                          action="mailto:contact@epistum.mk?subject=Demo Request&body=I`m requesting a demo for an e-course that I saw on your epistum-portfolio website"
                        >
                          <button className="btn-req-demo">
                            <span>Request Demo</span>
                          </button>
                        </form>
                      </div>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
